var map = {
	"./pe-admin-module/lng/ru-RU.json": 63859,
	"./pe-basic-module/lng/ru-RU.json": 71907,
	"./pe-fest-module/lng/ru-RU.json": 60756,
	"./pe-landing-module/lng/ru-RU.json": 19822,
	"./pe-local-works-module/lng/ru-RU.json": 29328,
	"./pe-tests-module/lng/ru-RU.json": 91386,
	"./pe-topos-module/lng/ru-RU.json": 71764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18192;